import { render } from "./seller_dashboard.vue?vue&type=template&id=19321910"
import script from "./seller_dashboard.vue?vue&type=script&lang=js"
export * from "./seller_dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__